import api from '../api/api';

/**
 * Bounded product analytics helper.
 * Strictly avoids PII and remains workspace-safe.
 */
export const trackEvent = async (type, metadata = {}) => {
    try {
        await api.post('/api/analytics/track', {
            type,
            metadata
        });
    } catch (err) {
        // Silently fail analytics to prevent product disruption
        console.error(`[Analytics] Failed to track ${type}:`, err.message);
    }
};

/**
 * Enum for supported product events to avoid typos.
 */
export const AdoptionEvents = {
    SEARCH_RUN: 'SEARCH_RUN',
    ADOPTION: 'ADOPTION',
    EXPORT: 'EXPORT',
    LIST_CREATED: 'LIST_CREATED',
    SEQUENCE_LAUNCH: 'SEQUENCE_LAUNCH',
    ASSET_SHARED: 'ASSET_SHARED',
    BILLING_VIEW: 'BILLING_VIEW',
    UPGRADE_INTENT: 'UPGRADE_INTENT',
    STRATEGY_OPEN: 'STRATEGY_OPEN',
    DETAIL_OPEN: 'DETAIL_OPEN',
    FRICTION_SIGNAL: 'FRICTION_SIGNAL'
};
